/*
* @描述: 菜单栏
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2022-11-23 17:40:11
*/
<template>
    <el-menu :default-active="defaultActive"
             unique-opened
             router
             menu-trigger="click">
        <template v-for="item in menuList">
            <el-menu-item :index="'/' + item.route" :key="item.id" v-if="!item.hasOwnProperty('child')">
                <i :class="item.icon"></i>
                <span v-text="item.title" slot="title"></span>
            </el-menu-item>
            <el-submenu :index="'/' + item.route" :key="item.id" v-else>
                <template slot="title">
                    <i :class="item.icon"></i>
                    <span slot="title">{{ item.title }}</span>
                </template>
                <template v-for="sub in item.child">
                    <el-menu-item :index="'/' + sub.route" :key="sub.id">
                        <span slot="title">{{ sub.title }}</span>
                    </el-menu-item>
                </template>
            </el-submenu>
        </template>
    </el-menu>
</template>
<script>
import { mapState } from 'vuex'
import {merchantAccount} from '@/utils/index'
    export default {
        props: {},
        data() {
            return {
                defaultActive: '',
                menuList: [
                    // {
                    //     id: '001',
                    //     title: '公司管理',
                    //     route: 'system/company',
                    //     icon: 'el-icon-s-home',
                    // },
                    {
                        id: '002',
                        title: '菜单管理',
                        route: 'system/treeNode',
                        icon: 'el-icon-menu',
                    },
                    {
                        id: '003',
                        title: '版本管理',
                        route: 'system/version',
                        icon: 'iconfont icon-banben'
                    },
                    {
                        id: '004',
                        title: '预约管理',
                        route: 'system/appoint',
                        icon: 'el-icon-postcard'
                    },
                  {
                    id: '005',
                    title: '租户管理',
                    route: 'system/tenant',
                    icon: 'el-icon-reading'
                  },
                  {
                    id: '006',
                    title: '系统维护',
                    route: 'system/upgrade',
                    icon: 'el-icon-lock'
                  },
                  {
                    id: '007',
                    title: '小程序管理',
                    route: 'system/shenlan',
                    icon: 'el-icon-s-opportunity',
                    child:[
                      {
                        id: '0074',
                        title: '商户管理',
                        route: 'system/company_management',
                        icon: 'el-icon-s-order',
                      },
                      {
                        id: '0071',
                        title: '电费权限',
                        route: 'system/electricity_management',
                        icon: 'el-icon-s-opportunity',
                      },
                      {
                        id: '0072',
                        title: '展项管理',
                        route: 'system/exhibition_management',
                        icon: 'el-icon-s-order',
                      },
                      {
                        id: '0073',
                        title: '展厅管理',
                        route: 'system/map_guide_management',
                        icon: 'el-icon-s-order',
                      }
                    ]
                  },
                ]
            }
        },
        computed: {
          ...mapState(['userInfo'])
        },
        created() {
            if(this.userInfo && this.userInfo.phone && merchantAccount.indexOf(this.userInfo.phone) > -1){
              this.menuList = [
                {
                  id: '007',
                  title: '小程序管理',
                  route: 'system/shenlan',
                  icon: 'el-icon-s-opportunity',
                  child:[

                    {
                      id: '0071',
                      title: '基础信息',
                      route: 'system/basic_information',
                      icon: 'el-icon-s-order',
                    },
                    {
                      id: '0072',
                      title: '展项管理',
                      route: 'system/exhibition_management',
                      icon: 'el-icon-s-order',
                    },
                    {
                      id: '0073',
                      title: '展厅管理',
                      route: 'system/map_guide_management',
                      icon: 'el-icon-s-order',
                    }
                  ]
                },
              ]
            }
            this.defaultActive = this.$route.path
            if(this.$route.path == '/system/exhibition_tpl'){
              this.defaultActive = '/system/exhibition_management'
            }
        },
        watch: {
            '$route.name': function (newVal, oldVal) {
                if (newVal) {
                    this.defaultActive = this.$route.path
                    if(this.$route.path == '/system/exhibition_tpl'){
                      this.defaultActive = '/system/exhibition_management'
                    }
                }
            }
        },
        methods: {}
    }
</script>

<style lang="scss">

  .vertical_menu {
    width: 220px;
    height: calc(100% - 60px);
    overflow-y: scroll;
  }

  .el-menu-item {
    height: 45px !important;
    line-height: 45px !important;
  }

  .el-submenu__title {
    height: 50px !important;
    line-height: 50px !important;
  }

  .el-menu--collapse .el-menu .el-submenu, .el-menu--popup {
    width: auto !important;
    min-width: fit-content !important;
  }

  .el-menu .iconfont {
    display: inline-block;
    margin-right: 5px;
    text-align: center;
    font-size: 18px;
    width: 24px;
    vertical-align: middle;
  }
</style>
